import { setShowClientContactModal } from '../State/showClientContactModal';

export default () => async (dispatch) => {

  dispatch(setShowClientContactModal(false));

}